// External dependencies.
import ProductMixin from '@/mixins/productMixin'

export default {
  name: 'product-preview',
  mixins: [ ProductMixin ],
  props: {
    product: {
      type: Object,
      default: { }
    },
    list: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    narrow: {
      type: Boolean,
      required: false
    }
  },
  components: { },
  data () {
    return {
      adding: false
    }
  },
  mounted () { },
  computed: {
    description () {
      const descriptions = this.product.descriptions
      const language = this.$store.getters.getCurrLanguage.iso.toLowerCase()
      if (descriptions[language]) {
        return descriptions[language]
      }
      return descriptions['en'] // @todo Default?
    },
    price () {
      const prices = this.product.prices
      if (prices[this.$store.getters.currency.currency]) {
        return prices[this.$store.getters.currency.currency]
      }
      return prices['SEK'] // @todo Default?
    }
  },
  methods: { }
}



// WEBPACK FOOTER //
// ./src/components/product-preview/script.js